import { render, staticRenderFns } from "./LoginWrap.vue?vue&type=template&id=9c7ca20c&scoped=true"
import script from "./LoginWrap.vue?vue&type=script&lang=js"
export * from "./LoginWrap.vue?vue&type=script&lang=js"
import style0 from "./LoginWrap.vue?vue&type=style&index=0&id=9c7ca20c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7ca20c",
  null
  
)

export default component.exports